export default __webpack_public_path__ + "static/media/mongoDb.2f70e12d.png";